//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'>
  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.events != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по событиям
  </div>
  <div v-else style="width:100vw; float:left">

    <div class="datalist">
    <div class="datalist-scroll" id="scrollingdiv">

    <!--p class="some-text">Добро пожаловать<span v-if="activeUser != null">, {{activeUser.name}}</span>!</p-->

    <div class="events-buttons">
      <div class="events-button events-button1" :class="viewMode == 1 ? 'events-button-active' : ''" @click="viewMode = 1">НОВОЕ</div>
      <div class="events-button events-button2" :class="viewMode == 3 ? 'events-button-active' : ''" @click="viewMode = 3">МОИ СОБЫТИЯ</div>
      <div class="events-button events-button3" :class="viewMode == 2 ? 'events-button-active' : ''" @click="viewMode = 2">ПРОШЛОЕ</div>
    </div>
    <div class="events-buttons-tags">
      <div class="events-button events-button-tag" :class="filterTag == '' ? 'events-button-active' : ''" @click="filterTag = ''">все</div>
      <div v-for="(tag, key) in serverData.appSettings.events.tags" :key="key" class="events-button events-button-tag"
          :class="filterTag == tag ? 'events-button-active' : ''"  @click="filterTag = tag">
        {{tag}}
      </div>
    </div>

    <div v-if="filteredData.length == 0" style="width:100%; padding:20px 20px 0 20px; font-size:17px; float:left">Нет событий</div>

    <div v-for="(event, key) in filteredData" :key="event.val.id">

      <DIV v-if="event.type == 2" class="date-title">
        {{event.text}}
      </DIV>

      <DIV v-else class="event" @click="if (preventToGoToEvent == false) dataRowOnSelect(event); preventToGoToEvent = false">

      <div class="event-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(event.val.body.images[0]) + ')'}">
        <div class="event-status" :style="{'background' : getEventStatusBackground(event)}" v-if="event.val.status != 1">
          {{getEventStatusText(event)}}<br>по причине: {{event.val.body.cancelReason}}
        </div>
        &nbsp;
      </div>

      <DIV class="event-info">
      <div style="width:100%; padding:0; float:left;">
        <div class="event-name">{{event.val.name}}</div>
      </div>

      <div class="event-prop" style="padding-top:10px;">
        <div class="link event-user-avatar" :style="{'background-image': 'url(' + serverData.imagesGetURL(serverData.usersMap[event.val.createdBy].body.avatar) + ')'}" @click="preventToGoToEvent = true; goToUserCard(event.val.createdBy)">&nbsp;</div>
        <div class="link" style="padding-top:4px; float:left;" @click="preventToGoToEvent = true; goToUserCard(event.val.createdBy)">{{serverData.usersMap[event.val.createdBy].name}}</div>
      </div>
      <div class="event-prop" style="padding-top:5px;">
        <span class="link" @click="preventToGoToEvent = true; goToPlaceCard(event.val.place)">{{serverData.placesMap[event.val.place].val.name}}</span>
      </div>

      <div style="width:50%; padding:10px 0 0 0; float:left;">
        <div class="event-prop-left" style="padding-top:0px;">{{event.val.dateStart | formatDate('date + weekday + reservedWords')}}</div>
        <div class="event-prop-left" style="padding-top:0px;">
          {{event.val.timeStart}} - {{event.val.timeEnd}}
        </div>
      </div>

      <div style="width:50%; padding:10px 0px 0px 0; float:left;">
        <!--div class="event-prop-right text-align-right">Сложность: {{event.val.level}}/5</div-->
        <!--div class="event-prop-right text-align-right" style="padding-top:21px">Участников: {{event.val.body.membersCount}}</div-->
        <div class="event-prop-right text-align-right" style="padding-top:0px" v-if="(event.membering.members.length > 0) || (event.membering.possible.length > 0)">Участники: {{event.membering.members.length}}</span></div>
        <div class="event-prop-right text-align-right" style="padding-top:0px">&nbsp;<span v-if="event.membering.possible.length > 0">Возможно: {{event.membering.possible.length}}</span></div>
        <!--div class="event-prop-right text-align-right">
          (мин: {{event.val.body.membersLimitFrom}}, макс: {{event.val.body.membersLimitTo}})
        </div-->
      </div>

      <div class="event-prop" style="padding-top:7px; text-align:center">{{event.val.price != 0 ? 'Стоимость: ' + event.val.price + ' р' : '&nbsp;'}}</div>

      <div style="width:100%; padding:0px 0px 20px 0; float:left;">&nbsp;</div>

      </DIV>
      </DIV>

    </div>

    <div class="bottom-space">&nbsp;</div>

    </div>
    </div>

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import arrayTools from '../technical/arrayTools/arrayTools.js'

// import Event from './Event.vue'

import serverData from '@/store/serverData'

export default {
  components: { },
  data () {
    return {
      data: [],

      viewMode: 1, // 1 - timline 2 - past 3 - events created by me & events где я участвую
      filterTag: '',

      serverData: serverData, // to make access from UI template

      timelineScrollEl: null,
      timelineScrollHeight: 0,

      preventToGoToEvent: false,
      loadingSpinner: false,

      eventStatuses: {
        ACTIVE: 1, // событие открыто для подписки
        HAPPENED: 2,  // событие случилось
        NO_INTERES: 3, // событие не случилось, не набралось людей, не интересно
        CANCELLED_BY_ORG: 10,
        CANCELLED_BY_ADMIN: 11, // пользователь сможет изменить статус т снова опубликовать
        BANNED_BY_ADMIN: 12 // пользователь не сможет изменить статус
        // DELETED - не делаем, есть CANCELLED что тоже самое
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ]),
    filteredData: function () {
      var filtered = []
      var today = new Date(Date.now())
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      var tomorrow = new Date(Date.now() + 1 * 24 * 3600 * 1000)
      tomorrow = new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate(), 0, 0, 0)
      var aftertomorrow = new Date(Date.now() + 2 * 24 * 3600 * 1000)
      aftertomorrow = new Date(aftertomorrow.getFullYear(), aftertomorrow.getMonth(), aftertomorrow.getDate(), 0, 0, 0)
      var thisWeekLast = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (7 - today.getDay()), 0, 0, 0)
      var thisMonthLast = new Date(today.getFullYear(), today.getMonth() + 1, 0, 0, 0, 0) // year, month + 1, day:0 (а не 1, это значит предыдущий день)

      for (var i = 0; i < this.data.length; i++) {
        var event = this.data[i]
        var statusApproved = event.val.status === this.eventStatuses.ACTIVE
        if ((this.activeUser != null) && (this.activeUser.id === event.val.createdBy)) statusApproved = true // если activeUser это орг события то показываем даже если событие CANCELLED и тд
        if ((this.activeUser != null) && ((this.activeUser.group === 0) || (this.activeUser.group === 1) || (this.activeUser.group === 2))) statusApproved = true // если суперпользователь или админ или модератор то показываем вообще все события даже если событие CANCELLED и тд
        var tagsApproved = event.val.tags.indexOf(this.filterTag) >= 0
        if (this.filterTag === '') tagsApproved = true
        if ((this.viewMode === 1) && (statusApproved) && (tagsApproved) && (new Date(event.val.dateEnd) >= today)) filtered.push(event)
        if ((this.viewMode === 2) && (statusApproved) && (tagsApproved) && (tagsApproved) && (new Date(event.val.dateEnd) < today)) filtered.push(event)
        if ((this.viewMode === 3) && (this.activeUser != null) && (tagsApproved) && (event.val.createdBy === this.activeUser.id)) filtered.push(event)
      }

      if (this.viewMode === 1) {
        arrayTools.sort(filtered, function (a, b) {
          if (a.val.dateStart === b.val.dateStart) {
            var res = window.mystrcmp(a.val.timeStart, b.val.timeStart)
            if (res === 0) return false
            if (res > 0) return true; else return false
          }
          return a.val.dateStart > b.val.dateStart
        })
        if ((filtered.length > 0) && (new Date(filtered[0].val.dateStart) < tomorrow)) filtered.splice(0, 0, {val: {id: -1}, type: 2, text: 'СЕГОДНЯ'})
        var tomorrowAdded = false
        var thisWeekAdded = false
        var thisMonthAdded = false
        var futherAdded = false
        for (i = 0; i < filtered.length; i++) {
          if ((filtered[i].type == null) && (tomorrowAdded === false) && (new Date(filtered[i].val.dateStart) >= tomorrow) && (new Date(filtered[i].val.dateStart) < aftertomorrow)) {
            filtered.splice(i++, 0, {val: {id: -1}, type: 2, text: 'ЗАВТРА'})
            tomorrowAdded = true
          }
          if ((filtered[i].type == null) && (thisWeekAdded === false) && (new Date(filtered[i].val.dateStart) >= aftertomorrow) && (new Date(filtered[i].val.dateStart) <= thisWeekLast)) {
            filtered.splice(i++, 0, {val: {id: -1}, type: 2, text: 'ТЕКУЩАЯ НЕДЕЛЯ'})
            thisWeekAdded = true
          }
          if ((filtered[i].type == null) && (thisMonthAdded === false) && (new Date(filtered[i].val.dateStart) > thisWeekLast) && (new Date(filtered[i].val.dateStart) <= thisMonthLast)) {
            filtered.splice(i++, 0, {val: {id: -1}, type: 2, text: 'ТЕКУЩИЙ МЕСЯЦ'})
            thisMonthAdded = true
          }
          if ((filtered[i].type == null) && (futherAdded === false) && (new Date(filtered[i].val.dateStart) > thisMonthLast)) {
            filtered.splice(i++, 0, {val: {id: -1}, type: 2, text: 'СЛЕДУЮЩИЙ МЕСЯЦ И ДАЛЕЕ'})
            futherAdded = true
          }
        }
      } else { // реверснутый порядок - от сейчас в прошлое
        arrayTools.sort(filtered, function (a, b) {
          if (a.val.dateStart === b.val.dateStart) {
            var res = window.mystrcmp(a.val.timeStart, b.val.timeStart)
            if (res === 0) return true
            if (res > 0) return false; else return true
          }
          return a.val.dateStart < b.val.dateStart
        })
      }
      return filtered
    }
  },
  created: function () {
    this.data = serverData.events // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event eventsChanged
    this.setTimelineScrolling()
    var thisRef = this
    serverData.eventsBus.$on('eventsTimelineSetScrollToTop', function () {
      // если первое нажатие то скролл к 0 но в рамках текущего viewMode. второе нажатие - меняем viewMode на timeline
      if (thisRef.timelineScrollHeight === 0) {
        thisRef.viewMode = 1
        thisRef.filterTag = ''
      } else {
        thisRef.timelineScrollHeight = 0
        thisRef.setTimelineScrolling()
      }
    })
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова. а если сначала смотрели /event/1, ушли, и снова смотрим но /event/2 то кроме как через watch route больше об этом не узнать
    $route: 'onRouteChange'
  },
  methods: {
    onRouteChange (route) {
      if ((route != null) && (route.path !== '/')) return // watch route вызыается при любых переходах между всеми страницами приложения
      this.setTimelineScrolling()
    },
    setTimelineScrolling () {
      this.timelineScrollEl = document.getElementById('scrollingdiv')
      if (this.timelineScrollEl != null) {
        var thisRef = this
        this.timelineScrollEl.addEventListener('scroll', function () { if (thisRef.timelineScrollEl != null) thisRef.timelineScrollHeight = thisRef.timelineScrollEl.scrollTop })
        this.timelineScrollEl.scrollTo(0, this.timelineScrollHeight)
      } else setTimeout(this.setTimelineScrolling, 10)
    },
    dataRowOnSelect (value) {
      this.$router.push({name: 'event', params: {id: value.val.id}})
    },
    goToUserCard (id) {
      this.$router.push({name: 'user', params: {id: id}})
    },
    goToPlaceCard (id) {
      this.$router.push({name: 'place', params: {id: id}})
    },
    getEventStatusText (event) {
      switch (event.val.status) {
        case 1: return 'Опубликовано'
        case 10: return 'Снято с публикации автором'
        case 11: return 'Снято с публикации админом'
        case 12: return 'Событие ЗАБАНЕННО админом'
        default: return 'Неизвестный статус события'
      }
    },
    getEventStatusBackground (event) {
      switch (event.val.status) {
        case 1: return '#666'
        case 10: return '#db3'
        case 11: return '#d33'
        case 12: return '#f00'
        default: return '#f00'
      }
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.datalist{
  height: 100%;
  width: 100%; /*320px;*/
  margin: 0px 0px 0px 0px;
  padding: 0px;
  background: #D9E0E7;
}
.datalist-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  height: calc(100vh - 50px);
}
@media screen and (min-width: 1000px) {
  .datalist {
    background: #D9E0E7;
  }
}
.event {
  width: 100%;
  /* max-width: 1000px; */
  margin: 0px 0px 25px 0px;
  cursor: pointer;
  float:left;
}
.event-image {
  width: 100%;
  height: 66vw;
  max-height: 400px;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 0px 0px;
  border: solid 0px #fff;
  float: left;
}
.event-info {
  width: 100%;
  height: 180px;
  padding: 0;
  background: #fff;
  border-radius: 0px 0px 20px 20px;
  border: solid 0px #fff;
  float: left;
}
.event-name {
  /* position: relative;
  top: calc(100% - 95px);
  z-index: 2;
  padding: 13px 35px 17px 12px;
  opacity: 0.85;
  background: #fff;
  color: #222; */
  padding: 10px 25px 0px 25px;
  color: #222;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  float:left;
}
.event-status {
  width: calc(100% - 40px);
  margin: 10px 20px 0 20px;
  padding: 5px 0 5px 0;
  font-size: 16px;
  font-weight: 400;
  background: #da3;
  color: #fff;
  text-align: center;
  border-radius: 8px 8px 8px 8px;
  float: left
}
.event-prop {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.event-prop-left {
  width: 100%;
  padding: 7px 5px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.event-prop-right {
  width: 100%;
  padding: 7px 25px 0px 5px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.event-user-avatar {
  width: 25px;
  height: 25px;
  margin-right: 5px;
  background: #555;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  border: solid 1px #e0e0e0;
  float: left;
}

@media screen and (min-width: 670px) { /* 650((300+25)*2) + 20scroll*/
  .event {
    max-width: calc((100% - 50px) / 2);
    margin: 0px 13px 25px 12px;
  }
  .event-image {
    height: 66vw;
    max-height: 300px;
  }
}
@media screen and (min-width: 995px) { /* 975((300+25)*3) + 20scroll*/
  .event {
    max-width: calc((100% - 75px) / 3);
  }
}
@media screen and (min-width: 1320px) { /* 1300((300+25)*4) + 20scroll*/
  .event {
    max-width: calc((100% - 100px) / 4);
  }
}
@media screen and (min-width: 1820px) { /* 1800((300+25)*4) + 20scroll*/
  .event-image {
    height: 66vw;
    max-height: 400px;
  }
}
.text-align-right {
  text-align:right;
}
.link {
  cursor: pointer;
}
.link:hover {
  color: #78b;
}
.bottom-space {
  width: 100%;
  padding: 50px 0 0 0;
  line-height: 0;
  float: left;
}
@media screen and (min-width: 450px) {
  .bottom-space {
    padding: 0;
  }
}
.events-buttons {
  width: 100%;
  padding: 0px 0 0px 0px;
  float: left
}
.events-button {
  margin: 0px 0px 0px 0px;
  padding: 3px 5px 3px 5px;
  color: #666;
  border-radius: 10px 10px 10px 10px;
  border: dashed 1px #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 17px;
  text-align: center;
  cursor: pointer;
  float:left;
}
.events-button1 {
  width: 23%;
  border-radius: 10px 0px 0px 10px;
  border-right: dashed 0px #666;
}
.events-button2 {
  width: 45%;
  border-radius: 0px 0px 0px 0px;
}
.events-button3 {
  width: 32%;
  border-radius: 0px 10px 10px 0px;
  border-left: dashed 0px #666;
}
@media screen and (max-width: 349px) {
  .events-buttons {
    padding: 17px 0px 7px 0px;
  }
  .events-button {
    font-size: 16px;
  }
}
@media screen and (min-width: 350px) and (max-width: 374px) {
  .events-buttons {
    padding: 17px 5px 7px 5px;
  }
}
@media screen and (min-width: 375px) and (max-width: 449px) {
  .events-buttons {
    padding: 17px 13px 7px 12px;
  }
  .events-button1 {width: 27%}
  .events-button2 {width: 42%}
  .events-button3 {width: 31%}
}
@media screen and (min-width: 450px) {
  .events-buttons {
    padding: 17px 13px 7px 12px;
  }
  .events-button1 {width: 120px;}
  .events-button2 {width: 170px;}
  .events-button3 {width: 120px;}
}
.events-button-active {
  color: #fff;
  border: solid 1px #889;
  background: #889;
  cursor: default;
}
.events-buttons-tags {
  width: 100%;
  padding: 7px 0 15px 12px;
  float:left;
}
.events-button-tag {
  margin: 0px 5px 5px 0px;
  padding: 2px 5px 2px 5px;
  border-radius: 5px 5px 5px 5px;
  font-size: 13px;
}
.date-title {
  width: calc(100% - 20px);
  margin: 10px 8px 30px 7px;
  padding: 10px 5px 10px 5px;
  color: #666;
  background: #d0d6de; /*#d9e0e7;*/
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 20px;
  border-radius: 5px;
  float:left;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Events.vue?67f0103f